/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { IObservationWithPearlCode } from '../../../../../Fhir/fhir_types';
import { DiagnosticReportAndObservations } from '../../../../../Fhir/fhir_utils';
import { State } from '../types';
import {
  addSummaryPlaceholders,
  compileObservationSummary,
  createSummarySectionHeaders,
  getObservationLabels,
  getObservationLine,
  getPanelName,
  getReportDateString,
  LINE_INTENDATION_PREFIX,
} from '../ruleUtils';
import { RuleEngineData } from '../patientSummaryRuleEngine';

export function ruleExtractLabs(data: RuleEngineData): Partial<State> {
  const { contextualizedWidgetReports } = data;

  const lifetimeDone: string[] = [];
  const done: string[] = [];
  const notDone: string[] = [];

  createSummarySectionHeaders({ data, done, notDone });

  Object.keys(contextualizedWidgetReports).forEach((widgetId) => {
    const { widget, reports } = contextualizedWidgetReports[widgetId]!;
    let panelName = getPanelName(widget);

    // if there are no reports, push the panel name to the not done array and skip to the next widget
    if (reports.length === 0) {
      notDone.push(`${LINE_INTENDATION_PREFIX}${panelName}`);
      return;
    }

    reports.forEach((report: DiagnosticReportAndObservations) => {
      let observations: string[] = [];
      // Get all the whitelisted observations irrespective of the interpretation
      report.observationList.forEach((observation: IObservationWithPearlCode) => {
        const observationLabels = getObservationLabels(observation);
        const observatationLine = getObservationLine(observationLabels);
        if (observatationLine) observations.push(observatationLine);
      });
      // Get all the hidden observations with interpretation
      report.hiddenObservationList.forEach((observation: IObservationWithPearlCode) => {
        const observationLabels = getObservationLabels(observation);
        if (observationLabels.interpretation) {
          const observatationLine = getObservationLine(observationLabels);
          if (observatationLine) observations.push(observatationLine);
        }
      });
      let doneTitle = `<b>${getReportDateString(report?.diagnosticReport)}, ${panelName}</b>`;

      compileObservationSummary({ widget, observations, lifetimeDone, done, notDone, doneTitle, panelName });
    });
  });

  addSummaryPlaceholders(notDone, done, lifetimeDone);

  return { labs: { done: lifetimeDone.concat(done), notDone: notDone } };
}
